const en = {
  language_label: 'Language',
  language_english: 'English',
  language_tamil: 'Tamil',
  module_navigation_aria: '{module} navigation',
  common_logout: 'Logout',
  common_module_not_found: 'Module not found',
  app_desktop_only_description:
    'This module is optimized for desktop screens. Please open it on a laptop or desktop for the full experience.',
  app_go_back: 'Go Back',
  followup_brand_name: 'FOLLOWUPS',

  reception_brand_name: 'RECEPTION',
  reception_brand_sub: 'Front Desk',
  reception_role_front_desk: 'Front Desk',
  reception_alert_recalls: 'Recalls',
  reception_alert_online: 'Online',
  reception_search_patient: 'Search patient...',
  reception_open_pharmacy: 'Open Pharmacy Module',
  reception_open_pharmacy_label: 'Pharmacy ↗',
  reception_view_queue: 'Queue',
  reception_view_calendar: 'Calendar',
  reception_tab_new_patient: 'New Patient',
  reception_tab_backdate_visit: 'Backdate Visit',
  reception_tab_visit_history: 'Visit History',
  reception_section_today_registration: "Today's Registration",
  reception_section_today_registration_sub:
    'Register a new walk-in patient for an immediate appointment.',
  reception_section_old_record: 'Old Record Entry',
  reception_section_old_record_sub: 'Digitize a previous visit from the physical notebook.',

  doctor_brand_name: 'CLINICAL',
  doctor_brand_sub: 'Doctor Station',
  doctor_role_default: 'Doctor',
  doctor_role_clinician: 'Clinician',
  doctor_tab_dashboard: 'Dashboard',
  doctor_tab_notes: 'Notes',
  doctor_tab_toothchart: 'Toothchart',
  doctor_tab_treatment_plan: 'Tx Plan',
  doctor_tab_perio: 'Perio',
  doctor_tab_history: 'History',
  doctor_tab_prescriptions: 'Prescriptions',
  doctor_tab_review_sign: 'Review & Sign',
  doctor_error_start_session: 'Unable to start session.',
  doctor_error_open_visit: 'Unable to open scheduled visit.',
  doctor_dashboard_title: 'Clinical Dashboard',
  doctor_dashboard_subtitle: "Manage your daily schedule and patient visits.",
  doctor_dashboard_waiting_room: 'Waiting Room',
  doctor_dashboard_completed: 'Completed',
  doctor_dashboard_jump_to_date: 'Jump to Date',
  doctor_dashboard_clinical_ops: 'Clinical Ops',
  doctor_dashboard_open_module: 'Open Module ↗',
  doctor_dashboard_quick_start: 'Quick Start (Walk-in)',
  doctor_dashboard_quick_start_sub: "Search patient and open today's visit.",

  manager_brand_name: 'MANAGER',
  manager_brand_sub: 'Operations',
  manager_role_default: 'Manager',
  manager_tab_dashboard: 'Dashboard',
  manager_tab_billing: 'Billing',
  manager_tab_inventory: 'Inventory',
  manager_tab_consultants: 'Consultants',
  manager_tab_labs: 'Labs',
  manager_tab_finance_reports: 'Finance Reports',
  manager_tab_patient_history: 'Patient History',
  manager_tab_clinic_notes: 'Clinic Notes',
  manager_alert_low_stock: 'Low Stock',
  manager_dashboard_clinical_operations: 'Clinical Operations',
  manager_dashboard_launch_module: 'Launch Module ↗',
  manager_dashboard_clinical_billing: 'Clinical Billing ↗',
  manager_dashboard_clinical_operations_sub:
    'Manage Endodontics, Extractions, Ortho, and other clinical workflows in a dedicated window.',
  manager_consultant_select_hint: 'Select a consultant to view ledger',

  pharmacy_brand_name: 'Pharmacy Console',
  pharmacy_navigation_aria: 'Pharmacy modules',
  pharmacy_tab_billing_dispense: 'Billing & Dispense',
  pharmacy_tab_sales_history: 'Sales History',
  pharmacy_tab_stock_inventory: 'Stock Inventory',
  pharmacy_tab_suppliers: 'Pharmacy Suppliers',
  pharmacy_tab_drug_notes: 'Drug Notes',
  pharmacy_tab_clinic_letters: 'Clinic Letters',

  mobile_brand_eyebrow: 'Unified Mobile Workspace',
  mobile_brand_title: 'CareFlow Mobile',
  mobile_nav_aria: 'Mobile CareFlow navigation',
  mobile_tab_careflow: 'CareFlow 360',
  mobile_tab_careflow_short: 'Care',
  mobile_tab_billing: 'Billing',
  mobile_tab_billing_short: 'Bill',
  mobile_tab_pharmacy: 'Pharmacy',
  mobile_tab_pharmacy_short: 'Rx',
  mobile_tab_finance: 'Finance',
  mobile_tab_finance_short: 'Money',
  mobile_tab_apps: 'Modules',
  mobile_tab_apps_short: 'Apps',
  mobile_tab_rct_queue: 'RCT Queue',
  mobile_tab_rct_queue_short: 'Queue',
  mobile_select_patient_title: 'Select a patient to open CareFlow',
  mobile_select_patient_sub:
    'Search and pick a patient from the bar above. We will auto-open today\'s visit and sync live updates.',
  mobile_billing_empty_title: 'Billing needs an active visit',
  mobile_billing_empty_sub:
    'Choose a patient first so invoice, receipts, and balance are tied to the correct clinical visit.',
  mobile_rct_queue_title: 'Real-time RCT Queue',
  mobile_live_label: 'Live',
  mobile_app_reception: 'Reception Desk',
  mobile_app_reception_sub: 'Intake, queue, and appointments',
  mobile_app_doctor: 'Doctor Station',
  mobile_app_doctor_sub: 'Clinical charting and review',
  mobile_app_manager: 'Manager Console',
  mobile_app_manager_sub: 'Operations and business controls',
  mobile_app_treatments: 'Treatments',
  mobile_app_treatments_sub: 'Clinical procedure workflows',
  mobile_app_pharmacy: 'Pharmacy Console',
  mobile_app_pharmacy_sub: 'Dispense and stock operations',
  mobile_end_session: 'End Session',
  mobile_unknown_patient: 'Unknown Patient',
  mobile_no_phone: 'No phone',
  mobile_visit_label: 'Visit',
  mobile_syncing: 'Syncing',
  mobile_ready: 'Ready',

  backup_title: 'Backups',
  backup_auto_policy: 'Auto-Backup Policy',
  backup_save_policy: 'Save Policy',
  backup_saving_policy: 'Saving...',
  backup_enable_scheduler: 'Enable Scheduler',
  backup_upload_drive: 'Upload to Drive',
  backup_frequency: 'Frequency',
  backup_frequency_daily: 'Daily',
  backup_frequency_weekly: 'Weekly',
  backup_frequency_biweekly: 'Bi-Weekly',
  backup_frequency_monthly: 'Monthly',
  backup_run_hour_utc: 'Run Hour (UTC)',
  backup_run_minute_utc: 'Run Minute (UTC)',
  backup_retention_days: 'Retention Days',
  backup_max_backups: 'Max Backups',
  backup_next_run: 'Next Run',
  backup_last_run: 'Last Run',

  careflow_title: 'Apexo-style Dental Charting',
  careflow_subtitle:
    'Separated treatment events, tooth history, collaboration notes, and conflict-safe sync.',
  careflow_stream_version: 'Stream version',
  careflow_updated: 'updated',
  careflow_hello: 'Hello',
  careflow_appointments_today: 'Appointments Today',
  careflow_new_patients_today: 'New Patients Today',
  careflow_payments_made_today: 'Payments Made Today',
  careflow_qr_button: 'Patient QR',
  careflow_qr_title: 'Patient QR Code',
  careflow_qr_close: 'Close',
  careflow_view_timeline: 'Timeline View',
  careflow_view_kanban: 'Kanban View',
  careflow_clinical_timeline: 'Clinical Timeline',
  careflow_current_treatments: 'Current Visit: Treatments',
  careflow_current_history: 'Current Visit: Tooth History',
  careflow_no_treatment_events: 'No treatment events for this visit.',
  careflow_no_history_entries: 'No tooth-history entries for this visit.',
  careflow_past_records: 'Past Records',
  careflow_audit_trail: 'Audit Trail',
  careflow_collab_notes: 'Collaboration Notes',
  careflow_collab_audit: 'Collaboration Audit',
  careflow_collab_none: 'No collaboration notes for this visit.',
  careflow_add_history: 'Add History',
  careflow_history_tooth: 'Tooth #',
  careflow_history_label: 'History label',
  careflow_history_note: 'Optional note',
  careflow_remove: 'Remove',
  careflow_add_note: 'Add Note',
  careflow_add_note_saving: 'Saving...',
  careflow_collab_note_placeholder: 'Add collaboration note for this visit...',
  careflow_collab_mentions_placeholder: 'Mentions (comma separated)',
  careflow_delete: 'Delete',
  careflow_live_status: 'Live',
  careflow_live_connecting: 'Connecting',
  careflow_live_open: 'Connected',
  careflow_live_closed: 'Disconnected',
  careflow_live_error: 'Connection error',
  careflow_live_unauthenticated: 'Authentication required',
  careflow_tags_placeholder: 'Add visit tags (e.g. Urgent, Follow-up)...',
  careflow_tags_saving: 'Saving tags...',
  careflow_tags_conflict: 'Tags merged from another session.',
  careflow_tags_error: 'Tag sync failed. Will retry on next change.',
  careflow_tags_synced_at: 'Tags synced at {when}',
  careflow_tooth_prefix: 'Tooth',
  careflow_event_label: 'event',
  careflow_historical_label: 'Historical',
  careflow_general_label: 'General',
  careflow_mentions_label: 'Mentions',
  careflow_note_prefix: 'Note #',
  portal_title: 'Thaila Dental Patient Portal',
  portal_subtitle: 'View upcoming appointments and request a new booking.',
  portal_find_title: 'Find My Appointments',
  portal_request_title: 'Request an Appointment',
  portal_mobile_placeholder: 'Mobile number',
  portal_name_placeholder: 'Full name',
  portal_view_btn: 'View Appointments',
  portal_empty: 'No upcoming visits found.',
  portal_status_open: 'OPEN',
  portal_age_placeholder: 'Age',
  portal_gender_placeholder: 'Gender',
  portal_gender_male: 'Male',
  portal_gender_female: 'Female',
  portal_gender_other: 'Other',
  portal_doctor_placeholder: 'Preferred doctor (optional)',
  portal_notes_placeholder: 'Notes / concerns',
  portal_request_btn: 'Submit Request',
  portal_error_missing: 'Enter mobile number and name.',
  portal_error_lookup: 'Unable to find appointments. Check name + mobile.',
  portal_request_success: 'Appointment request submitted. We will contact you soon.',
  portal_request_fail: 'Failed to submit request. Please try again.',
};

export default en;
